<template>
  <div ref="stencilcontainer" class="stencil-container"></div>
</template>

<script setup lang="ts">
import { inject, onMounted } from "vue";
import RappidContext from "./rappid/rappid-context";
import { StencilService } from "./services/stencil-service";
import { toolbarHeight } from "./utils/resizeCard";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");
const stencilService: StencilService = inject<StencilService>("stencilService");

function renderPlugin(selector: string, plugin: { el: HTMLElement; render() }): void {
  document.querySelector(selector)?.appendChild(plugin.el);
  plugin.render();
}

function load() {
  rappidContext.stencil.load(stencilService.getContent());
}

onMounted(() => {
  renderPlugin(".stencil-container", rappidContext.stencil);
  load();
});
</script>
<style scoped>
.stencil-container {
  position: absolute;
  top: v-bind(toolbarHeight);
  height: 420px;
  width: 50px;
  border-top: 2px solid rgba(var(--v-theme-contrast-grey-medium));
}

.joint-stencil {
  border: 0px !important;
}
</style>
